define('display/layers/labelsLayer',["leaflet", "./tileLayer"], function (L) {
    "use strict";

    L.TomTomLabelsLayer = L.TomTomLayer.extend({
        options: {
        },
        initialize: function (options) {
            var labelsOptions = L.extend({}, options, {layer: "labels", opacity: 0.9});
            L.TomTomLayer.prototype.initialize.call(this, labelsOptions);
        },
        onAdd: function (map) {
            var that = this;
            map.on("layeradd", function () {
                if (map._panes.tilePane.childElementCount > 1 || map._panes.overlayPane.childElementCount > 0) {
                    if (!that._container) {
                        L.TomTomLayer.prototype.onAdd.call(that, map);
                    }
                    that.bringToFront();
                }
            });
        },
        bringToFront: function () {
            var pane = this._map._panes.overlayPane;
            if (this._container) {
                pane.appendChild(this._container);
                this._setAutoZIndex(pane, Math.max);
            }
            return this;
        },
        _initContainer: function () {
            var tilePane = this._map._panes.overlayPane;

            if (!this._container) {
                this._container = L.DomUtil.create('div', 'leaflet-transparent-layer');

                this._updateZIndex();

                if (this._animated) {
                    var className = 'leaflet-tile-container';

                    this._bgBuffer = L.DomUtil.create('div', className, this._container);
                    this._tileContainer = L.DomUtil.create('div', className, this._container);

                } else {
                    this._tileContainer = this._container;
                }

                tilePane.appendChild(this._container);

                if (this.options.opacity < 1) {
                    this._updateOpacity();
                }
            }
        },
    });

    L.tomTomLabelsLayer = function (options) {
        return new L.TomTomLabelsLayer(options);
    };

    return L.tomTomLabelsLayer;
});
